module.exports = __webpack_public_path__ + "static/media/whiteLogo.53dbea7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/whiteLogo.png
// module id = 160
// module chunks = 0